import script from "./productdetails.vue?vue&type=script&setup=true&lang=js"
export * from "./productdetails.vue?vue&type=script&setup=true&lang=js"

import "./productdetails.vue?vue&type=style&index=0&id=29651b37&scoped=true&lang=css"

import exportComponent from "C:\\Users\\97813\\Desktop\\汇智衣\\sd_hq_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29651b37"]])

export default __exports__